
import React from 'react';
import { SnackbarProvider } from "notistack";
import { Routes, Route } from 'react-router-dom';
import { AdminAuthProvider } from './context/AdminAuthContext';
import { StudentAuthProvider } from './context/StudentAuthContext';
// import logo from './logo.svg';
import './style/style.scss';

// components
import Header from './components/common/Header';
import { Footer } from './components/common/Footer';

// Pages
import { Home } from './pages/Home';
import ThankYou from "./pages/ThankYou";
import F04 from "./pages/404";
import { RegisterPage } from './pages/RegisterPage';
import { StudentLoginPage } from './pages/StudentLoginPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { StudentsDashBoard } from './pages/StudentsDashBoardPage';
import AdminSignIn from './pages/AdminSignIn';
import AdminPanel from './pages/AdminPanel';
import AdminProtectedRoute from './Routes/AdminProtectedRoute';
import StudentProtectedRoute from './Routes/StudentProtectedRoute';
import { AuthDebug } from './components/debugg/AuthDebug';

function App() {
  return (
    <>
      <SnackbarProvider
        maxSnack={1}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        preventDuplicate
      >
        <AdminAuthProvider>
          <StudentAuthProvider>
            <Header />
             {/* <AuthDebug /> Add this line */}
            <Routes>
              <Route
                path="/admin-panel"
                element={
                  <AdminProtectedRoute>
                    <AdminPanel />
                  </AdminProtectedRoute>
                }
              />

              <Route
                path="/students-dashboard"
                element={
                  <StudentProtectedRoute>
                    <StudentsDashBoard />
                  </StudentProtectedRoute>
                }
              />

              <Route exact path='/' element={<Home />} />
              <Route exact path='/home' element={<Home />} />
              <Route exact path='/thank-you' element={<ThankYou />} />
              <Route exact path="/students-registration" element={<RegisterPage />} />
              <Route exact path="/students-login" element={<StudentLoginPage />} />
              <Route exact path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path='/admin-login' element={<AdminSignIn />} />
              <Route path='/authdebugg' element={<AuthDebug />} />
              <Route exact path="*" element={<F04 />} />
            </Routes>
          </StudentAuthProvider>
        </AdminAuthProvider>
        <Footer />
      </SnackbarProvider>
    </>
  );
}

export default App;



